import { Component, Output, EventEmitter, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
	selector: 'app-confirm-modal',
	templateUrl: './confirm-modal.component.html',
	styleUrls: ['./confirm-modal.component.scss']
})
export class ConfirmModalComponent {
	title = '';
	message = '';
	@Output() response: EventEmitter<boolean> = new EventEmitter();

	constructor(
		public dialogRef: MatDialogRef<ConfirmModalComponent>,
		@Inject(MAT_DIALOG_DATA) public data: { title: string; message: string }
	) {}

	confirm(): void {
		this.dialogRef.close(true); 
	}

	decline(): void {
		this.dialogRef.close(false); 
	}
}



